import React, { useState } from 'react';
import { createContactMessage } from '../services/contactService';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    testimony: false
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.testimony) {
      setStatus({ type: 'error', message: 'Debe aceptar las condiciones para enviar el testimonio.' });
      return;
    }

    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      await createContactMessage(formData);
      setStatus({ type: 'success', message: 'Enviado correctamente, lo atenderemos a la mayor brevedad posible.' });
      setFormData({ name: '', email: '', subject: '', message: '', testimony: false });
    } catch (error) {
      setStatus({ type: 'error', message: 'No fue posible guardar su información, intente mas tarde.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="form-group mb-3">
                <label htmlFor="name">Nombre</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="form-group mb-3">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="subject">Asunto</label>
                <input
                  type="text"
                  className="form-control"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="message">Mensaje</label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <h4>Testimonios</h4>
          <p className="small">
            Los datos personales y de contacto de los devotos del Santo Cristo de la Piedad que voluntariamente compartan su testimonio a través de la página web no serán entregados ni compartidos con persona jurídica o natural alguna, excepto en caso de ser requeridos por la Iglesia Católica, a fin de ser utilizados para eventuales investigaciones que esta decida adelantar en relación con el Santo Cristo de la Piedad. En este caso, los datos serán entregados de manera exclusiva a la Curia Arquidiocesana de la ciudad de Medellín o a quien los requiera directamente desde El Vaticano.
          </p>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="testimony"
              name="testimony"
              checked={formData.testimony}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="testimony">
              Reconozco que he leído y acepto las condiciones.
            </label>
          </div>
        </div>
        <div className="col-12 col-md-4 col-lg-2 py-3">
          <button
            type="submit"
            className="btn btn-primary btn-block w-100"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Enviando...' : 'Enviar'}
          </button>
        </div>
        <div className="col-12 col-md-8 col-lg-10 py-3">
          {status.message && (
            <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'}`} role="alert">
              {status.message}
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default ContactForm;